/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateSupplierCommand } from '../models';
// @ts-ignore
import { CreateSupplierPaymentCommand } from '../models';
// @ts-ignore
import { DeleteSupplierPaymentCommand } from '../models';
// @ts-ignore
import { RecordSupplierPaymentCommand } from '../models';
// @ts-ignore
import { SupplierDetailsDto } from '../models';
// @ts-ignore
import { SupplierDtoPaginatedList } from '../models';
// @ts-ignore
import { SupplierPaymentDto } from '../models';
// @ts-ignore
import { SupplierPaymentDtoPaginatedList } from '../models';
// @ts-ignore
import { UpdateSupplierCommand } from '../models';
// @ts-ignore
import { UpdateSupplierPaymentCommand } from '../models';
/**
 * SuppliersApi - axios parameter creator
 * @export
 */
export const SuppliersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber]
         * @param {number} [pageSize]
         * @param {string} [searchTerm]
         * @param {boolean} [isActive]
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersGet: async (pageNumber?: number, pageSize?: number, searchTerm?: string, isActive?: boolean, projectId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSuppliersIdDelete', 'id', id)
            const localVarPath = `/api/Suppliers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSuppliersIdGet', 'id', id)
            const localVarPath = `/api/Suppliers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSupplierCommand} [updateSupplierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersIdPut: async (id: number, updateSupplierCommand?: UpdateSupplierCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSuppliersIdPut', 'id', id)
            const localVarPath = `/api/Suppliers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupplierCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [supplierId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [isPaid] 
         * @param {boolean} [isPartiallyPaid] 
         * @param {boolean} [isDue] 
         * @param {number} [projectId] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsGet: async (supplierId?: number, pageNumber?: number, pageSize?: number, isPaid?: boolean, isPartiallyPaid?: boolean, isDue?: boolean, projectId?: number, categoryId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Suppliers/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['SupplierId'] = supplierId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (isPaid !== undefined) {
                localVarQueryParameter['IsPaid'] = isPaid;
            }

            if (isPartiallyPaid !== undefined) {
                localVarQueryParameter['IsPartiallyPaid'] = isPartiallyPaid;
            }

            if (isDue !== undefined) {
                localVarQueryParameter['IsDue'] = isDue;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['CategoryId'] = categoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteSupplierPaymentCommand} [deleteSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsIdDelete: async (id: number, deleteSupplierPaymentCommand?: DeleteSupplierPaymentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSuppliersPaymentsIdDelete', 'id', id)
            const localVarPath = `/api/Suppliers/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSupplierPaymentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSuppliersPaymentsIdGet', 'id', id)
            const localVarPath = `/api/Suppliers/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordSupplierPaymentCommand} [recordSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsIdPatch: async (id: number, recordSupplierPaymentCommand?: RecordSupplierPaymentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSuppliersPaymentsIdPatch', 'id', id)
            const localVarPath = `/api/Suppliers/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordSupplierPaymentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSupplierPaymentCommand} [updateSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsIdPut: async (id: number, updateSupplierPaymentCommand?: UpdateSupplierPaymentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSuppliersPaymentsIdPut', 'id', id)
            const localVarPath = `/api/Suppliers/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupplierPaymentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSupplierPaymentCommand} [createSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsPost: async (createSupplierPaymentCommand?: CreateSupplierPaymentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Suppliers/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupplierPaymentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSupplierCommand} [createSupplierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPost: async (createSupplierCommand?: CreateSupplierCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupplierCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuppliersApi - functional programming interface
 * @export
 */
export const SuppliersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuppliersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber]
         * @param {number} [pageSize]
         * @param {string} [searchTerm]
         * @param {boolean} [isActive]
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersGet(pageNumber?: number, pageSize?: number, searchTerm?: string, isActive?: boolean, projectId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersGet(pageNumber, pageSize, searchTerm, isActive, projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSupplierCommand} [updateSupplierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersIdPut(id: number, updateSupplierCommand?: UpdateSupplierCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersIdPut(id, updateSupplierCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [supplierId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [isPaid] 
         * @param {boolean} [isPartiallyPaid] 
         * @param {boolean} [isDue] 
         * @param {number} [projectId] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersPaymentsGet(supplierId?: number, pageNumber?: number, pageSize?: number, isPaid?: boolean, isPartiallyPaid?: boolean, isDue?: boolean, projectId?: number, categoryId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierPaymentDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersPaymentsGet(supplierId, pageNumber, pageSize, isPaid, isPartiallyPaid, isDue, projectId, categoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteSupplierPaymentCommand} [deleteSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersPaymentsIdDelete(id: number, deleteSupplierPaymentCommand?: DeleteSupplierPaymentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersPaymentsIdDelete(id, deleteSupplierPaymentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersPaymentsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierPaymentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersPaymentsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordSupplierPaymentCommand} [recordSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersPaymentsIdPatch(id: number, recordSupplierPaymentCommand?: RecordSupplierPaymentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersPaymentsIdPatch(id, recordSupplierPaymentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSupplierPaymentCommand} [updateSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersPaymentsIdPut(id: number, updateSupplierPaymentCommand?: UpdateSupplierPaymentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersPaymentsIdPut(id, updateSupplierPaymentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSupplierPaymentCommand} [createSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersPaymentsPost(createSupplierPaymentCommand?: CreateSupplierPaymentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersPaymentsPost(createSupplierPaymentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSupplierCommand} [createSupplierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSuppliersPost(createSupplierCommand?: CreateSupplierCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSuppliersPost(createSupplierCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SuppliersApi - factory interface
 * @export
 */
export const SuppliersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuppliersApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber]
         * @param {number} [pageSize]
         * @param {string} [searchTerm]
         * @param {boolean} [isActive]
         * @param {number} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersGet(pageNumber?: number, pageSize?: number, searchTerm?: string, isActive?: boolean, projectId?: number, options?: any): AxiosPromise<SupplierDtoPaginatedList> {
            return localVarFp.apiSuppliersGet(pageNumber, pageSize, searchTerm, isActive, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiSuppliersIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersIdGet(id: number, options?: any): AxiosPromise<SupplierDetailsDto> {
            return localVarFp.apiSuppliersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSupplierCommand} [updateSupplierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersIdPut(id: number, updateSupplierCommand?: UpdateSupplierCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiSuppliersIdPut(id, updateSupplierCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [supplierId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [isPaid] 
         * @param {boolean} [isPartiallyPaid] 
         * @param {boolean} [isDue] 
         * @param {number} [projectId] 
         * @param {number} [categoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsGet(supplierId?: number, pageNumber?: number, pageSize?: number, isPaid?: boolean, isPartiallyPaid?: boolean, isDue?: boolean, projectId?: number, categoryId?: number, options?: any): AxiosPromise<SupplierPaymentDtoPaginatedList> {
            return localVarFp.apiSuppliersPaymentsGet(supplierId, pageNumber, pageSize, isPaid, isPartiallyPaid, isDue, projectId, categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {DeleteSupplierPaymentCommand} [deleteSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsIdDelete(id: number, deleteSupplierPaymentCommand?: DeleteSupplierPaymentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiSuppliersPaymentsIdDelete(id, deleteSupplierPaymentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsIdGet(id: number, options?: any): AxiosPromise<SupplierPaymentDto> {
            return localVarFp.apiSuppliersPaymentsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordSupplierPaymentCommand} [recordSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsIdPatch(id: number, recordSupplierPaymentCommand?: RecordSupplierPaymentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiSuppliersPaymentsIdPatch(id, recordSupplierPaymentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateSupplierPaymentCommand} [updateSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsIdPut(id: number, updateSupplierPaymentCommand?: UpdateSupplierPaymentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiSuppliersPaymentsIdPut(id, updateSupplierPaymentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSupplierPaymentCommand} [createSupplierPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPaymentsPost(createSupplierPaymentCommand?: CreateSupplierPaymentCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiSuppliersPaymentsPost(createSupplierPaymentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSupplierCommand} [createSupplierCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSuppliersPost(createSupplierCommand?: CreateSupplierCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiSuppliersPost(createSupplierCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiSuppliersGet operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersGetRequest
 */
export interface SuppliersApiApiSuppliersGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof SuppliersApiApiSuppliersGet
     */
    readonly searchTerm?: string

    /**
     *
     * @type {boolean}
     * @memberof SuppliersApiApiSuppliersGet
     */
    readonly isActive?: boolean

    /**
     *
     * @type {number}
     * @memberof SuppliersApiApiSuppliersGet
     */
    readonly projectId?: number
}

/**
 * Request parameters for apiSuppliersIdDelete operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersIdDeleteRequest
 */
export interface SuppliersApiApiSuppliersIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiSuppliersIdGet operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersIdGetRequest
 */
export interface SuppliersApiApiSuppliersIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiSuppliersIdPut operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersIdPutRequest
 */
export interface SuppliersApiApiSuppliersIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateSupplierCommand}
     * @memberof SuppliersApiApiSuppliersIdPut
     */
    readonly updateSupplierCommand?: UpdateSupplierCommand
}

/**
 * Request parameters for apiSuppliersPaymentsGet operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersPaymentsGetRequest
 */
export interface SuppliersApiApiSuppliersPaymentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsGet
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {boolean}
     * @memberof SuppliersApiApiSuppliersPaymentsGet
     */
    readonly isPaid?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof SuppliersApiApiSuppliersPaymentsGet
     */
    readonly isPartiallyPaid?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof SuppliersApiApiSuppliersPaymentsGet
     */
    readonly isDue?: boolean

    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsGet
     */
    readonly projectId?: number

    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsGet
     */
    readonly categoryId?: number
}

/**
 * Request parameters for apiSuppliersPaymentsIdDelete operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersPaymentsIdDeleteRequest
 */
export interface SuppliersApiApiSuppliersPaymentsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsIdDelete
     */
    readonly id: number

    /**
     * 
     * @type {DeleteSupplierPaymentCommand}
     * @memberof SuppliersApiApiSuppliersPaymentsIdDelete
     */
    readonly deleteSupplierPaymentCommand?: DeleteSupplierPaymentCommand
}

/**
 * Request parameters for apiSuppliersPaymentsIdGet operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersPaymentsIdGetRequest
 */
export interface SuppliersApiApiSuppliersPaymentsIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiSuppliersPaymentsIdPatch operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersPaymentsIdPatchRequest
 */
export interface SuppliersApiApiSuppliersPaymentsIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsIdPatch
     */
    readonly id: number

    /**
     * 
     * @type {RecordSupplierPaymentCommand}
     * @memberof SuppliersApiApiSuppliersPaymentsIdPatch
     */
    readonly recordSupplierPaymentCommand?: RecordSupplierPaymentCommand
}

/**
 * Request parameters for apiSuppliersPaymentsIdPut operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersPaymentsIdPutRequest
 */
export interface SuppliersApiApiSuppliersPaymentsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof SuppliersApiApiSuppliersPaymentsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateSupplierPaymentCommand}
     * @memberof SuppliersApiApiSuppliersPaymentsIdPut
     */
    readonly updateSupplierPaymentCommand?: UpdateSupplierPaymentCommand
}

/**
 * Request parameters for apiSuppliersPaymentsPost operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersPaymentsPostRequest
 */
export interface SuppliersApiApiSuppliersPaymentsPostRequest {
    /**
     * 
     * @type {CreateSupplierPaymentCommand}
     * @memberof SuppliersApiApiSuppliersPaymentsPost
     */
    readonly createSupplierPaymentCommand?: CreateSupplierPaymentCommand
}

/**
 * Request parameters for apiSuppliersPost operation in SuppliersApi.
 * @export
 * @interface SuppliersApiApiSuppliersPostRequest
 */
export interface SuppliersApiApiSuppliersPostRequest {
    /**
     * 
     * @type {CreateSupplierCommand}
     * @memberof SuppliersApiApiSuppliersPost
     */
    readonly createSupplierCommand?: CreateSupplierCommand
}

/**
 * SuppliersApi - object-oriented interface
 * @export
 * @class SuppliersApi
 * @extends {BaseAPI}
 */
export class SuppliersApi extends BaseAPI {
    /**
     * 
     * @param {SuppliersApiApiSuppliersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersGet(requestParameters: SuppliersApiApiSuppliersGetRequest = {}, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.isActive, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersIdDelete(requestParameters: SuppliersApiApiSuppliersIdDeleteRequest, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersIdGet(requestParameters: SuppliersApiApiSuppliersIdGetRequest, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersIdPut(requestParameters: SuppliersApiApiSuppliersIdPutRequest, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersIdPut(requestParameters.id, requestParameters.updateSupplierCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersPaymentsGet(requestParameters: SuppliersApiApiSuppliersPaymentsGetRequest = {}, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersPaymentsGet(requestParameters.supplierId, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.isPaid, requestParameters.isPartiallyPaid, requestParameters.isDue, requestParameters.projectId, requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersPaymentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersPaymentsIdDelete(requestParameters: SuppliersApiApiSuppliersPaymentsIdDeleteRequest, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersPaymentsIdDelete(requestParameters.id, requestParameters.deleteSupplierPaymentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersPaymentsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersPaymentsIdGet(requestParameters: SuppliersApiApiSuppliersPaymentsIdGetRequest, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersPaymentsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersPaymentsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersPaymentsIdPatch(requestParameters: SuppliersApiApiSuppliersPaymentsIdPatchRequest, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersPaymentsIdPatch(requestParameters.id, requestParameters.recordSupplierPaymentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersPaymentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersPaymentsIdPut(requestParameters: SuppliersApiApiSuppliersPaymentsIdPutRequest, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersPaymentsIdPut(requestParameters.id, requestParameters.updateSupplierPaymentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersPaymentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersPaymentsPost(requestParameters: SuppliersApiApiSuppliersPaymentsPostRequest = {}, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersPaymentsPost(requestParameters.createSupplierPaymentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SuppliersApiApiSuppliersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    public apiSuppliersPost(requestParameters: SuppliersApiApiSuppliersPostRequest = {}, options?: AxiosRequestConfig) {
        return SuppliersApiFp(this.configuration).apiSuppliersPost(requestParameters.createSupplierCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
